import { useMutation } from "react-query";
import { upsertVariablesImpactingTreatment } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertVariablesImpactingTreatment = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertVariablesImpactingTreatment(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the treatment variables.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    upsertVariablesImpactingTreatmentMutation: mutate,
    isUpsertVariablesImpactingTreatmentLoading: isLoading,
    ...rest,
  };
};

export default useUpsertVariablesImpactingTreatment;
